<template>
	<div class="notice block">
		<block-header title="全网公示" />
		<div class="table">
			<el-table :data="tableData" style="width: 100%;" :show-header="false" @row-click="onClickNotice">
				<el-table-column label="城市" :width="14 * 3 + 70" prop="school.district_division.l2_name"></el-table-column>
				<el-table-column label="地区" :width="14 * 3 + 70" prop="school.district_division.l3_name"></el-table-column>
				<el-table-column label="学校" :width="14 * 15 + 70" prop="school.name"></el-table-column>
				<el-table-column label="内容" prop="title"></el-table-column>
				<el-table-column label="日期" :width="14 * 8 + 35">
					<template v-slot:default="slot">
						<p class="date">{{ slot.row.updated_at | dateonly }}</p>
					</template>
				</el-table-column>
				<div slot="empty" class="empty-data">暂无全网公示</div>
			</el-table>
			<router-link v-if="!tableData && tableData.length === 0" class="more" to="/public_notice"
				>更多<svg class="icon" aria-hidden="true" style="margin-left: 4px;">
					<use xlink:href="#icon-iconfillenter"></use></svg
			></router-link>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tableData: []
		}
	},
	async created() {
		let res = await this.$api.public_notice.listPublic()
		this.tableData = res.data
	},
	methods: {
		onClickNotice(row) {
			this.$router.push('/public_notice/' + row.id)
		}
	}
}
</script>
<style lang="scss" scoped>
.block {
	background: #fff;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	border-radius: 8px;
}
.notice {
	border-radius: 8px;
	.table {
		padding: 15px;
		p {
			margin: 0;
		}
		.date {
			text-align: right;
			font-size: 14px;
			color: rgba(144, 147, 153, 1);
		}
	}
	.more {
		display: inline-block;
		border: 1px solid #ebeef5;
		width: 100%;
		text-align: center;
		height: 40px;
		line-height: 40px;
		background: #f9f9f9;
		border-radius: 3px;
		color: #cccccc;
	}
}
</style>
